export function size(props) {
    if (typeof props.size === 'number') {
        return props.size;
    }
    if (typeof props.sizes[props.size] === 'number') {
        return props.sizes[props.size];
    }
    return +props.sizes[props.size]?.value || +props.sizes.md?.value;
}
